import React, { useContext, createContext } from 'react';
import { Link } from 'react-router-dom';

import { CartContext } from '../context/CartContext';



const Cart = () => {
  const { cartItems, updateQuantity, removeFromCart, clearCart } = useContext(CartContext);

  // ✅ CÁLCULO DINÁMICO DEL TOTAL
  // Calcula el total sumando el precio * cantidad de todos los items en tiempo real.
  // Esto garantiza que el precio SIEMPRE se actualice cuando cambias la cantidad.
  const total = cartItems?.reduce((sum, item) => {
    const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 1;
    return sum + (price * quantity);
  }, 0) || 0;

  if (!cartItems || cartItems.length === 0) {
    return (
      <>
        <style>{`
          .empty-cart-page {
            min-height: 70vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #F9F6F0;
            padding: 2rem;
            font-family: 'Inter', sans-serif;
          }
          .empty-cart-card {
            background: #FFFFFF;
            padding: 4rem 3rem;
            border-radius: 24px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
            text-align: center;
            max-width: 500px;
            width: 100%;
            border: 1px solid rgba(139, 69, 19, 0.1);
          }
          .empty-cart-icon {
            font-size: 5rem;
            display: block;
            margin-bottom: 1.5rem;
            color: #D2B48C;
          }
          .empty-cart-card h2 {
            font-family: 'Playfair Display', serif;
            font-size: 2.2rem;
            color: #1A1A1A;
            margin-bottom: 1rem;
          }
          .empty-cart-card p {
            color: #666666;
            margin-bottom: 2.5rem;
            line-height: 1.6;
          }
          .btn-continue {
            display: inline-block;
            background-color: #8B4513;
            color: #FFFFFF;
            padding: 1rem 2.5rem;
            border-radius: 50px;
            text-decoration: none;
            font-weight: 600;
            transition: all 0.3s ease;
          }
          .btn-continue:hover {
            background-color: #1A1A1A;
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          }
        `}</style>
        <div className="empty-cart-page">
          <div className="empty-cart-card">
            <span className="empty-cart-icon">🛒</span>
            <h2>Tu carrito está vacío</h2>
            <p>Aún no has agregado ningún producto. ¡Explora nuestra selección de café de altura y encuentra tu favorito!</p>
            <Link to="/products" className="btn-continue">
              Explorar Productos
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{`
        :root {
          --primary-color: #8B4513;
          --primary-hover: #A0522D;
          --secondary-color: #D2B48C;
          --dark-bg: #1A1A1A;
          --light-bg: #F9F6F0;
          --text-main: #2C2C2C;
          --text-light: #666666;
          --white: #FFFFFF;
          --radius-md: 12px;
          --radius-lg: 24px;
          --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 10px 30px rgba(0, 0, 0, 0.08);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .cart-page-wrapper {
          background-color: var(--light-bg);
          min-height: 80vh;
          padding: 4rem 5%;
          font-family: 'Inter', -apple-system, sans-serif;
          color: var(--text-main);
        }

        .cart-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .cart-header h1 {
          font-family: 'Playfair Display', serif;
          font-size: 3rem;
          color: var(--dark-bg);
          margin-bottom: 0.5rem;
        }

        .cart-header p {
          color: var(--text-light);
          font-size: 1.1rem;
        }

        .cart-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 3rem;
          align-items: start;
        }

        /* CART ITEMS LIST */
        .cart-items-wrapper {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .cart-item {
          display: flex;
          align-items: center;
          background: var(--white);
          padding: 1.5rem;
          border-radius: var(--radius-md);
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(0,0,0,0.05);
          position: relative;
          transition: var(--transition);
        }

        .cart-item:hover {
          box-shadow: var(--shadow-md);
          transform: translateY(-2px);
        }

        .cart-item-image {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 8px;
          margin-right: 1.5rem;
          background-color: #F5F5F5;
        }

        .cart-item-info {
          flex-grow: 1;
        }

        .cart-item-info h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.3rem;
          color: var(--dark-bg);
          margin-bottom: 0.5rem;
        }

        .cart-item-price {
          color: var(--primary-color);
          font-weight: 600;
          font-size: 1.1rem;
        }

        /* QUANTITY CONTROLS */
        .cart-item-actions {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .quantity-control {
          display: flex;
          align-items: center;
          background: var(--light-bg);
          border-radius: 50px;
          padding: 0.3rem;
          border: 1px solid #E0E0E0;
        }

        .quantity-btn {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--white);
          border: none;
          border-radius: 50%;
          font-size: 1.2rem;
          cursor: pointer;
          color: var(--dark-bg);
          transition: var(--transition);
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .quantity-btn:hover:not(:disabled) {
          background: var(--primary-color);
          color: var(--white);
        }

        .quantity-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .quantity-value {
          width: 40px;
          text-align: center;
          font-weight: 600;
          font-size: 1rem;
        }

        .cart-item-subtotal {
          font-weight: 800;
          font-size: 1.2rem;
          color: var(--dark-bg);
          min-width: 120px;
          text-align: right;
        }

        .remove-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          color: #999;
          font-size: 1.5rem;
          cursor: pointer;
          transition: var(--transition);
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }

        .remove-btn:hover {
          color: #D32F2F;
          background: rgba(211, 47, 47, 0.1);
        }

        /* SUMMARY SECTION */
        .cart-summary {
          background: var(--dark-bg);
          color: var(--white);
          padding: 2.5rem;
          border-radius: var(--radius-lg);
          position: sticky;
          top: 2rem;
          box-shadow: var(--shadow-lg);
        }

        .cart-summary h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.8rem;
          margin-bottom: 2rem;
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 1rem;
          color: var(--secondary-color);
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 1rem;
          font-size: 1.05rem;
          color: #E0E0E0;
        }

        .summary-row.envio {
          font-size: 0.9rem;
          color: #A0A0A0;
          margin-bottom: 2rem;
        }

        .summary-row.total {
          border-top: 1px solid rgba(255,255,255,0.2);
          padding-top: 1.5rem;
          margin-top: 1rem;
          margin-bottom: 2rem;
          font-size: 1.4rem;
          font-weight: 800;
          color: var(--white);
        }

        .cart-actions {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .checkout-btn {
          background: var(--secondary-color);
          color: var(--dark-bg);
          text-align: center;
          padding: 1.2rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 700;
          font-size: 1.1rem;
          transition: var(--transition);
          display: block;
        }

        .checkout-btn:hover {
          background: var(--white);
          transform: translateY(-2px);
        }

        .clear-cart-btn {
          background: transparent;
          color: #A0A0A0;
          border: 1px solid rgba(255,255,255,0.2);
          padding: 1rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .clear-cart-btn:hover {
          background: rgba(255,255,255,0.1);
          color: var(--white);
          border-color: var(--white);
        }

        /* RESPONSIVE DESIGN */
        @media (max-width: 968px) {
          .cart-container {
            grid-template-columns: 1fr;
          }
          
          .cart-summary {
            position: relative;
            top: 0;
          }

          .cart-item {
            flex-direction: column;
            align-items: flex-start;
            padding-top: 2.5rem;
          }

          .cart-item-image {
            margin-bottom: 1rem;
            width: 80px;
            height: 80px;
          }

          .cart-item-actions {
            width: 100%;
            justify-content: space-between;
            margin-top: 1rem;
            border-top: 1px solid #EEE;
            padding-top: 1rem;
          }
        }
      `}</style>

      <div className="cart-page-wrapper">
        <div className="cart-header">
          <h1>Tu Carrito de Compras</h1>
          <p>Revisa tus productos antes de finalizar tu pedido</p>
        </div>
        
        <div className="cart-container">
          <div className="cart-items-wrapper">
            {cartItems.map(item => {
              const price = Number(item.price) || 0;
              const quantity = Number(item.quantity) || 1;
              const subtotal = price * quantity;
              
              return (
                <div key={item.id} className="cart-item">
                  <button 
                    onClick={() => removeFromCart(item.id)}
                    className="remove-btn"
                    aria-label="Eliminar producto"
                    title="Eliminar producto"
                  >
                    ×
                  </button>

                  <img 
                    src={item.image || 'https://images.unsplash.com/photo-1442512595331-e89e73853f31'} 
                    alt={item.name} 
                    className="cart-item-image" 
                    onError={(e) => { e.target.src = '/images/default-product.jpg'; }}
                  />
                  
                  <div className="cart-item-info">
                    <h3>{item.name}</h3>
                    <p className="cart-item-price">${price.toFixed(2)} MXN</p>
                  </div>
                  
                  <div className="cart-item-actions">
                    <div className="quantity-control">
                      <button 
                        onClick={() => updateQuantity(item.id, quantity - 1)}
                        className="quantity-btn"
                        disabled={quantity <= 1}
                      >
                        −
                      </button>
                      <span className="quantity-value">{quantity}</span>
                      <button 
                        onClick={() => updateQuantity(item.id, quantity + 1)}
                        className="quantity-btn"
                      >
                        +
                      </button>
                    </div>
                    
                    <div className="cart-item-subtotal">
                      ${subtotal.toFixed(2)} MXN
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          
          <div className="cart-summary">
            <h3>Resumen del Pedido</h3>
            
            <div className="summary-row">
              <span>Subtotal:</span>
              <span>${total.toFixed(2)} MXN</span>
            </div>
            
            <div className="summary-row envio">
              <span>Envío:</span>
              <span>Se calculará en el siguiente paso</span>
            </div>
            
            <div className="summary-row total">
              <span>Total Estimado:</span>
              <span>${total.toFixed(2)} MXN</span>
            </div>
            
            <div className="cart-actions">
              <Link to="/checkout" className="checkout-btn">
                Proceder al Pago
              </Link>
              <button onClick={clearCart} className="clear-cart-btn">
                Vaciar Carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;